import { Avatar, GetProp, notification, Upload, UploadFile, UploadProps } from "antd"
import { RcFile } from "antd/es/upload"
import { useState } from "react"
import AvatarModal from "./AvatarModal"

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0]

type Props = {
  src: string
  avatarSize?: number
  alt: string
  onModalSubmit: (newAvatar: string) => void
}

const AvatarPicker = ({ src, avatarSize, alt, onModalSubmit }: Props) => {
  const [avatarDataBase64, setAvatarDataBase64] = useState<string>('')
  const [showAvatarModal, setShowAvatarModal] = useState(false)

  const checkIfImageIsLessThan5MB = (file: FileType) => {
    return file.size / 1024 / 1024 < 5
  }

  const beforeUpload = (file: FileType) => {
    if(checkIfImageIsLessThan5MB(file)){
      return true
    }

    notification.error({ message: 'File must be less than 5MB' })
    return false
  }
  
  const handleUploadAvatar = (info: { fileList: UploadFile[] }) => {
    const lastFileIndex = info.fileList.length - 1
    const file = info.fileList[lastFileIndex]?.originFileObj as File | undefined
    
    if (file) {
      if (!checkIfImageIsLessThan5MB(file as RcFile)) {
        return
      }
      
      const reader = new FileReader()
      reader.onloadend = () => {
        const base64data = reader.result as string
        setAvatarDataBase64(base64data)
        setShowAvatarModal(true)
      }
      reader.readAsDataURL(file)
    }
  }
  
  const handleAvatarChange = (croppedDataUrl: string) => {
    setShowAvatarModal(false)
    onModalSubmit(croppedDataUrl)
  }

  return <>
    <Upload
      showUploadList={false}
      beforeUpload={beforeUpload}
      onChange={handleUploadAvatar}
    >
      <Avatar
        size={avatarSize ?? 110}
        src={src}
        alt={alt}
        style={{ cursor: 'pointer', border: '5px solid #10A983' }}
      />
    </Upload>

    <AvatarModal
      open={showAvatarModal}
      imageData={avatarDataBase64}
      onSubmit={handleAvatarChange}
      onCancel={() => setShowAvatarModal(false)}
    />
  </>
}

export default AvatarPicker